import React, { useEffect } from 'react';
import { Form } from 'antd';

import { setStaticFormValuesFromFilter } from '../../common/filterHelpers';
import { SearchFormProps } from '../../common/searchFormField.types';
import { ReminderObjectClassEnum, ReminderTypeEnum } from '../../common/types';
import { FormCheckbox } from '../../components/forms/FormCheckbox';
import { FormDatePicker } from '../../components/forms/FormDatePicker';
import { FormDoubleInput } from '../../components/forms/FormDoubleInput';
import { FormInput } from '../../components/forms/FormInput';
import { FormSelectMultiple } from '../../components/forms/FormSelectMultiple';
import { StyledColumn } from '../../components/StyledColumn';

export const typeOptions = Object.values(ReminderTypeEnum).map((preference) => ({
  value: preference,
  content: preference,
}));

export const objectClassOptions = Object.values(ReminderObjectClassEnum).map((preference) => ({
  value: preference,
  content: preference,
}));

export const RemindersSearchForm: React.FC<SearchFormProps> = ({ form, filter }) => {
  useEffect(() => setStaticFormValuesFromFilter(form, filter), [filter, form]);

  return (
    <Form form={form} style={{ flexGrow: '1' }} layout="vertical" colon={false}>
      <StyledColumn gap="0.5rem">
        <FormInput name="title" label="Title" />

        <FormDoubleInput
          leftInput={<FormDatePicker name={['date', 'start']} label="Remind at from" />}
          rightInput={<FormDatePicker name={['date', 'end']} label="Remind at to" />}
          withDivider
        />

        <FormCheckbox label="Active" name="active" />

        <FormSelectMultiple name="type" label="Reminder type" options={typeOptions} />

        <FormSelectMultiple name="objectClass" label="Reminder for" options={objectClassOptions} />

        <FormDoubleInput
          leftInput={<FormInput name="user.firstName" label="User first name" />}
          rightInput={<FormInput name="user.lastName" label="User last name" />}
        />
      </StyledColumn>
    </Form>
  );
};
